import { User } from 'oidc-client';
import React from 'react';
import AuthState from './AuthState';

export interface IAuthContext extends AuthState {
  signInSilent: () => Promise<User>;
  signInRedirect: (path?: string) => void;
  signOut: () => void;
  signOutRedirectCallback: () => void;
  hasPermission: (permissionName: string) => boolean;
}

export const AuthContext = React.createContext<IAuthContext | null>(null);

export const useAuth = (): IAuthContext => React.useContext(AuthContext) as IAuthContext;
